













// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/activity/edit/EditContent.vue'
import { getDefaultAloActivity, AloActivity } from '@/models/alo/AloActivity';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'ReadContent',    
   props: {
    activity:{      
      default:getDefaultAloActivity()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadContent extends Vue {
  private activity!:AloActivity
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.activity) }
}
